// function htmlEncode(t){return t?$("<div/>").text(t).html():""}function is_touch_device(){return"ontouchstart"in window||navigator.maxTouchPoints}$(function(){var oldFlickityCreate=window.Flickity.prototype._create,resizeTimeout;window.Flickity.prototype._create=function(){var t=this;return this.element.addEventListener&&this.element.addEventListener("load",function(){t.onresize()},!0),this._create=oldFlickityCreate,oldFlickityCreate.apply(this,arguments)},imageFunctions.flickityIosFix(),objectFitImages(),header.loadMegaMenu(),header.init(),Shopify.theme_settings.enable_autocomplete&&searchAutocomplete.init(),utils.pageBannerCheck(),slideshow.init(),testimonial.init(),videoSection.init(),gallery.init(),featuredPromotions.init(),featuredCollectionSection.init(),collectionSidebarFilter.init(),cart.init(),mapFunction.init(),productPage.initializeQuantityBox(),productPage.init(),recentlyViewed.init(),window.addEventListener("resize",function(t){resizeTimeout||(resizeTimeout=setTimeout(function(){resizeTimeout=null,$(window).width()<=798&&(cart.init(),header.unload(),header.init())},66))},!1),$.fancybox.defaults.animationEffect="fade",$.fancybox.defaults.transitionEffect="fade",$.fancybox.defaults.hash=!1,$.fancybox.defaults.infobar=!1,$.fancybox.defaults.toolbar=!1,$.fancybox.defaults.arrows=!1,$.fancybox.defaults.loop=!0,$.fancybox.defaults.smallBtn=!0,$.fancybox.defaults.live=!1,$.fancybox.defaults.zoom=!1,$.fancybox.defaults.mobile.preventCaptionOverlap=!1,$.fancybox.defaults.mobile.toolbar=!0,$.fancybox.defaults.mobile.buttons=["close"],$.fancybox.defaults.mobile.clickSlide="close",$.fancybox.defaults.mobile.clickContent="zoom",$.fancybox.defaults.afterLoad=function(t,e){"image"==t.current.type&&e.$content.wrapInner("<div class='fancybox-image-wrap'></div>"),t.group.length>1&&e.$content.find(".fancybox-image-wrap").append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+svgArrowSizeLeft+'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+svgArrowSizeRight+"</span></a>")},$('.lightbox[rel="gallery"]').fancybox(),$(".article_content iframe, .page iframe").wrap('<div class="lazyframe" data-ratio="16:9"></div>'),$(".shopify-policy__container").parent().prepend('<a name="pagecontent" id="pagecontent"></a>');var currentValue=$(".search_form input[name='q']").val();$(".search_form input[name='q']").length>0&&$(".search_form input[name='q']").val(currentValue.replace("*","")),$("#sort-by").val($("#sort-by").data("default-sort")),$("body").on("change","#tag_filter, #sort-by",function(){quickFilter.init()}),$("body").on("change","#blog_filter",function(){var t=$(this).val();window.location=t}),$("input, select, textarea").on("focus blur",function(t){$("meta[name=viewport]").attr("content","width=device-width,initial-scale=1,maximum-scale="+("blur"==t.type?10:1))}),$("body").on("change","[data-option-filter] input",function(){quickFilter.init(),$("html, body").animate({scrollTop:$("#pagecontent").offset().top},500)}),$("body").on("click","[data-reset-filters]",function(){collectionSidebarFilter.clearAllFilters()}),$("body").on("click","[data-clear-filter]",function(){var t=$(this).parents(".filter-active-tag");collectionSidebarFilter.clearSelectedFilter(t)}),$("body").on("change",".currencies",function(t){$("[data-initial-modal-price]").attr("data-initial-modal-price","")}),$("body").on("change",".js-quick-shop select",function(t){var e=$('.js-quick-shop select[name="id"]').val();e&&globalQuickShopProduct&&quickShop.updateVariant(e)}),Shopify.theme_settings.quick_shop_enabled&&quickShop.init();var touchStartPos=0;if($(document).bind("touchstart",function(t){touchStartPos=$(window).scrollTop()}).bind("touchend",function(t){var e=touchStartPos-$(window).scrollTop();(e>20||e<-20)&&t.preventDefault}),$("body").on("click",".sidebar .parent-link--false",function(t){t.preventDefault(),$menu=$(this).parent("li"),$menu.find(".menu-toggle").toggleClass("active"),$menu.find("ul").slideToggle()}),Shopify.theme_settings.newsletter_popup&&newsletter_popup.init(),-1!=window.location.pathname.indexOf("/comments")&&$("html,body").animate({scrollTop:$("#new-comment").offset().top-140},"slow"),$("body").on("mouseenter",".icon-search",function(){$(".search-terms").focus()}),$("body").on("click",".icon-search",function(){$("input.search-terms").focus()}),$("body").on("click",".search-submit",function(){$(this).parent().submit()}),$(window).width()>798&&($(".animate_right").waypoint(function(){$(this.element).addClass("animated fadeInRight")},{offset:"70%"}),$(".animate_left").waypoint(function(){$(this.element).addClass("animated fadeInLeft")},{offset:"70%"}),$(".animate_up").waypoint(function(){$(this.element).addClass("animated fadeInUp")},{offset:"70%"}),$(".animate_down").waypoint(function(){$(this.element).addClass("animated fadeInDown")},{offset:"70%"})),$(".slider, .flexslider").find("li").unwrap(),$(".slider, .flexslider").flickity({pageDots:usePageDots,imagesLoaded:!0,arrowShape:arrowSize,lazyLoad:2}),utils.createAccordion(".toggle-all--true","h4.toggle","ul.toggle_list"),utils.createAccordion(".footer_menu","h6","ul"),utils.createAccordion(".footer_content","h6","div.toggle_content"),utils.createAccordion(".product_section .accordion-tabs",".tabs li > a",".tabs-content li"),utils.mobileParentActiveAccordion("#mobile_menu","li.sublink > a.parent-link--true span","li.sublink ul"),utils.mobileAccordion("#mobile_menu","li.sublink > a.parent-link--false","li.sublink ul"),utils.initializeTabs(),utils.resizeActionButtons(),faqAccordion.init(),$(window).on("resize",function(){utils.resizeActionButtons()}),$(window).width()<=798&&utils.createAccordion(".toggle-all--false","h4.toggle","ul.toggle_list"),$("body").on("click",".menu-toggle",function(t){$(this).next("ul").slideToggle(),$(this).toggleClass("active"),$(this).attr("aria-expanded","true"==$(this).attr("aria-expanded")?"false":"true")}),$(window).width()>=959){var modal_width="870px";($(window).width()>=1200||$("html").hasClass("ie"))&&(modal_width="1110px")}if(Shopify.theme_settings.collection_swatches&&$(window).width()>798&&($("body").on("mouseenter",".collection_swatches",function(){$(".swatch span",$(this)).each(function(){-1==$(this).data("image").indexOf("no-image")&&($("<img/>")[0].src=$(this).data("image"))})}),$("body").on("mouseenter",".swatch span",function(){-1==$(this).data("image").indexOf("no-image")&&($(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("src",$(this).data("image")),$(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("srcset",$(this).data("image")))})),Shopify.theme_settings.display_tos_checkbox&&$("body").on("click touchstart",".cart_content .tos_label",function(){$(this).prev("input").prop("checked",!0)}),Shopify.theme_settings.display_tos_checkbox&&Shopify.theme_settings.go_to_checkout?$("body").on("click",".tos_warning .action_button",function(t){if(!$(this).parents("form").find(".tos_agree").is(":checked")){var e='<p class="warning animated bounceIn">'+Shopify.translation.agree_to_terms_warning+"</p>";return 0==$("p.warning").length&&$(this).before(e),!1}Shopify.theme_settings.go_to_checkout?$(this).submit():(t.preventDefault(),document.location.href="/cart")}):Shopify.theme_settings.go_to_checkout||$("body").on("click",".cart_content .action_button",function(t){t.preventDefault(),document.location.href="/cart"}),Shopify.theme_settings.collection_secondary_image&&imageFunctions.showSecondaryImage(),$("[data-is-required]").length){var $checkboxGroup=$(".contact-block--checkbox input");$checkboxGroup.prop("required",!0),$(".contact-block--checkbox [data-is-required] input").on("change",function(){$checkboxGroup.prop("required",!0),$checkboxGroup.is(":checked")&&$checkboxGroup.prop("required",!1)})}var $contact_form=$(".newsletter .contact-form");function ajaxSubmitCart(t){$cart=t,$.ajax({url:"/cart/update.js",dataType:"json",cache:!1,type:"post",data:$cart.serialize(),success:function(t){refreshCart(t)}})}function updateCartItemQuantity(t){$.ajax({url:"/cart/change.js",dataType:"json",cache:!1,type:"post",data:{quantity:t.quantity,line:t.lineID},success:function(e){var i=e.items,a=t.lineID-1,o=t.parentCartForm.find("[data-variant-id]").length,n=t.parentCartForm.find('[data-variant-id="'+t.variantID+'"] input'),s=0,r=0,c=void 0!==e.items[a]?e.items[a].quantity:0;if(n.length>1?($.each(n,function(t,e){s+=parseInt($(e).val())}),i.forEach(function(e){e.variant_id===t.variantID&&(r+=e.quantity)})):(s=parseInt(n.val()),r=void 0!==e.items[a]?e.items[a].quantity:0),s>0&&s>r)if(items_left_text=1==r?Shopify.translation.one_item_left:Shopify.translation.items_left_text,$(".warning--quantity").remove(),o<i.length)"cart-template"===t.parentCartForm.data("cart-form")?t.parentCartForm.submit():refreshCart(e);else{var l='<p class="warning warning--quantity animated bounceIn">'+r+" "+items_left_text+"</p>";t.parentCartForm.find("[data-line-id='"+t.lineID+"'] input").parent().after(l),t.parentCartForm.find("[data-line-id='"+t.lineID+"'] input").val(c)}else"cart-template"===t.parentCartForm.data("cart-form")?t.parentCartForm.submit():refreshCart(e)}})}function refreshCartID(){for(var t=document.querySelectorAll(".cart__item"),e=0;e<t.length;e++)for(var i=e+1,a=t[e].querySelectorAll("[data-line-id]"),o=0;o<a.length;o++)a[o].dataset.lineId=i}function refreshCart(t){$(".cart_count").empty(),$cartBtn=$(".cart_count");var e=$cartBtn.text()||"0",a="",o="",n="",s="",r=$("[data-cart-form]"),c=!1,l=0,d=0;if(r.data("total-discount",t.total_discount),$cartBtn.text(e.replace(/[0-9]+/,t.item_count)),0==t.item_count)$(".js-empty-cart__message").removeClass("hidden"),r.addClass("hidden");else{$(".js-empty-cart__message").addClass("hidden"),r.removeClass("hidden");var p=0,u=0;$.each(t.items,function(t,e){var o=e.discounts,n="";for(i=0;i<o.length;i++){Shopify.formatMoney(o[i].amount,$("body").data("money-format"));n='<p class="notification-discount meta">'+o[i].title+"</p>"}var s=t+1;if(a+='<li class="mini-cart__item clearfix" data-cart-item data-line-id="'+s+'" data-variant-id="'+e.id+'"><a href="'+e.url+'">',e.image&&(a+='<div class="cart_image"><img src="'+e.image.replace(/(\.[^.]*)$/,"_compact$1").replace("http:","")+'" alt="'+htmlEncode(e.title)+'" /></div></a>'),a+='<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="'+e.url+'">'+e.title+"</a></div>",e.properties&&$.each(e.properties,function(t,e){e&&(a+='<div class="line-item">'+t+": "+e+" </div>")}),a+='<strong class="right price">',$.ajax({dataType:"json",async:!1,cache:!1,url:"/products/"+e.handle+".js",success:function(t){if(t.variants){var i=t.variants;if(i.length>1)for(v=0;v<i.length;v++)if(i[v].id==e.id)t=i[v]}t.compare_at_price?t.compare_at_price>t.price&&(c=!0,l=t.compare_at_price,d=t.price):c=!1}}),1==c){var r=Shopify.formatMoney(d,$("body").data("money-format"))+' </span><span class="money was_price">'+Shopify.formatMoney(l,$("body").data("money-format"))+"</span>";a+='<span class="money sale">'+r+"</strong>",u=(l-d)*e.quantity,p=u+p}else if(e.price>e.final_price){r=Shopify.formatMoney(e.final_price,$("body").data("money-format"))+' </span><span class="money was_price">'+Shopify.formatMoney(e.price,$("body").data("money-format"))+"</span>";a+='<span class="money sale">'+r+"</strong>"}else{r=Shopify.formatMoney(e.price,$("body").data("money-format"));a+='<span class="money">'+r+"</span></strong>"}e.price>e.final_price&&(a+=n),a+='<div class="left product-quantity-box">',a+='<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>',a+='<input type="number" min="0" class="quantity" name="updates[]" id="updates_'+e.id+'" value="'+e.quantity+'" data-cart-quantity-input="mini-cart" />',a+='<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>',a+="</div></div></div>",a+='<a href="/cart/change?line='+s+'&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="'+s+'" data-remove-item="mini-cart"><span class="remove-icon"></span></a>'});var h=t.cart_level_discount_applications;for(i=0;i<h.length;i++){var f=Shopify.formatMoney(h[i].total_allocated_amount,$("body").data("money-format"));o+='<span class="cart_discounts--title">'+h[i].title+"</span>",o+='<span class="cart_discounts--price">',o+='-<span class="money">'+f+"</span></span>"}n+='<span class="right"><span class="money">'+Shopify.formatMoney(t.total_price,$("body").data("money-format"))+"</span></span><span>"+Shopify.translation.cart_subtotal_text+"</span>",p+=t.total_discount,s=Shopify.theme_settings.display_savings&&p>0?'<span class="right"><span class="money">'+Shopify.formatMoney(p,$("body").data("money-format"))+"</span></span><span>"+Shopify.translation.cart_savings_text+"</span>":""}$(".js-cart_items").html(a),$(".js-cart_discounts").html(o),$(".js-cart_subtotal").html(n),$(".js-cart_savings").html(s),Shopify.theme_settings.show_multiple_currencies&&convertCurrencies()}$contact_form.each(function(){var t=$(this);t.on("submit",function(e){"true"!==$('input[name="challenge"]',t).val()&&($.ajax({type:t.attr("method"),url:t.attr("action"),data:t.serialize(),success:function(e){t.fadeOut("slow",function(){t.prev(".message").html(Shopify.translation.newsletter_success_text)})},error:function(e){$('input[name="challenge"]',t).val("true"),t.submit()}}),e.preventDefault())})}),$(".maps").click(function(){$(".maps iframe").css("pointer-events","auto")}),"load_more"==Shopify.theme_settings.pagination_type&&enableLoadMoreProducts(),"infinite_scroll"==Shopify.theme_settings.pagination_type&&enableInfiniteScroll(),"load_more"==Shopify.theme_settings.search_pagination_type&&enableLoadMoreSearch(),"infinite_scroll"==Shopify.theme_settings.search_pagination_type&&enableInfiniteSearchScroll(),$("body").on("change","[data-cart-quantity-input]",function(){var t={lineID:$(this).parents("[data-cart-item]").data("line-id"),variantID:$(this).parents("[data-cart-item]").data("variant-id"),quantity:$(this).val(),parentCartForm:$(this).parents("[data-cart-form]"),totalDiscount:$(this).parents("[data-cart-form]").data("total-discount"),$element:$(this).parents("[data-cart-item]")};$(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled"),updateCartItemQuantity(t)}),$("body").on("click","[data-remove-item]",function(t){t.preventDefault();var e={lineID:$(this).parents("[data-cart-item]").data("line-id"),variantID:$(this).parents("[data-cart-item]").data("variant-id"),quantity:0,parentCartForm:$(this).parents("[data-cart-form]"),totalDiscount:$(this).parents("[data-cart-form]").data("total-discount"),$element:$(this).parents("[data-cart-item]")};e.$element.addClass("animated fadeOutLeft"),updateCartItemQuantity(e),"cart-template"===e.parentCartForm.data("cart-form")&&(e.$element.find("input").val("0"),e.parentCartForm.submit()),"mini-cart"===e.parentCartForm.data("cart-form")&&e.$element.find("input").val("0")}),"ajax"==Shopify.theme_settings.cart_action&&$(document).on("click",".ajax-submit",function(e){e.preventDefault();var $addToCartForm=$(this).closest("form"),$addToCartBtn=$addToCartForm.find(".add_to_cart");return $.ajax({url:"/cart/add.js",dataType:"json",cache:!1,type:"post",data:$addToCartForm.serialize(),beforeSend:function(){$addToCartBtn.attr("disabled","disabled").addClass("disabled"),$addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")},success:function(t){$addToCartBtn.find(".checkmark").addClass("checkmark-active"),window.setTimeout(function(){$addToCartBtn.removeAttr("disabled").removeClass("disabled"),$addToCartBtn.find(".checkmark").removeClass("checkmark-active"),$addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")},1e3),$.ajax({url:"/cart.js",dataType:"json",cache:!1,success:function(t){setTimeout(function(){(refreshCart(t),$("body").hasClass("fancybox-active")&&$.fancybox.close(),$("#header").is(":visible")?$("#header .cart_container").addClass("active_link"):$(".sticky_nav--stick").length?$(".sticky_nav .cart_container").addClass("active_link"):$(".top_bar .cart_container").addClass("active_link"),$(window).width()<=798)&&($(this).parent().hasClass("active_link"),$("body").addClass("blocked-scroll"));$("body").hasClass("cart")&&$addToCartForm.submit()},500)}})},error:function(XMLHttpRequest){var response=eval("("+XMLHttpRequest.responseText+")");response=response.description,$(".warning").remove();var warning='<p class="warning animated bounceIn">'+response.replace("All 1 ","All ")+"</p>";$addToCartForm.after(warning),$addToCartBtn.removeAttr("disabled").removeClass("disabled"),$addToCartBtn.find("span").text(Shopify.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn")}}),!1}),productPage.productSwatches()}),Shopify.updateOptionsInSelector=function(t,e){switch(t){case 0:var i="root";$(e+" .single-option-selector:eq(0)");break;case 1:i=$(e+" .single-option-selector:eq(0)").val(),$(e+" .single-option-selector:eq(1)");break;case 2:i=$(e+" .single-option-selector:eq(0)").val();i+=" / "+$(e+" .single-option-selector:eq(1)").val();$(e+" .single-option-selector:eq(2)")}var a=Shopify.optionsMap[i];$(e+' .swatch[data-option-index="'+t+'"] .swatch-element').each(function(){-1!==$.inArray($(this).attr("data-value"),a)?$(this).removeClass("soldout").find(":radio").removeAttr("disabled","disabled").removeAttr("checked"):$(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled","disabled")})},Shopify.linkOptionSelectors=function(t,e){Shopify.optionsMap={};for(var i=0;i<t.variants.length;i++){var a=t.variants[i];if(a.available){if(Shopify.optionsMap.root=Shopify.optionsMap.root||[],Shopify.optionsMap.root.push(a.option1),Shopify.optionsMap.root=Shopify.uniq(Shopify.optionsMap.root),t.options.length>1){var o=a.option1;Shopify.optionsMap[o]=Shopify.optionsMap[o]||[],Shopify.optionsMap[o].push(a.option2),Shopify.optionsMap[o]=Shopify.uniq(Shopify.optionsMap[o])}if(3===t.options.length){o=a.option1+" / "+a.option2;Shopify.optionsMap[o]=Shopify.optionsMap[o]||[],Shopify.optionsMap[o].push(a.option3),Shopify.optionsMap[o]=Shopify.uniq(Shopify.optionsMap[o])}}}Shopify.updateOptionsInSelector(0,e),t.options.length>1&&Shopify.updateOptionsInSelector(1,e),3===t.options.length&&Shopify.updateOptionsInSelector(2,e),$(e+" .single-option-selector:eq(0)").change(function(){return Shopify.updateOptionsInSelector(1,e),3===t.options.length&&Shopify.updateOptionsInSelector(2,e),!0}),$(e+" .single-option-selector:eq(1)").change(function(){return 3===t.options.length&&Shopify.updateOptionsInSelector(2,e),!0})};var touch_device=/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);function floatToString(t,e){var i=t.toFixed(e).toString();return i.match(/^\.\d+/)?"0"+i:i}if(void 0===Shopify)var Shopify={};Shopify.each=function(t,e){for(var i=0;i<t.length;i++)e(t[i],i)},Shopify.map=function(t,e){for(var i=[],a=0;a<t.length;a++)i.push(e(t[a],a));return i},Shopify.arrayIncludes=function(t,e){for(var i=0;i<t.length;i++)if(t[i]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],i=0;i<t.length;i++)Shopify.arrayIncludes(e,t[i])||e.push(t[i]);return e},Shopify.isDefined=function(t){return void 0!==t},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function i(){}i.prototype=e.prototype,t.prototype=new i,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){return(Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e)+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var i="option"+(t+1);return null==e[i]?null:e[i]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(i){for(var a=!0,o=0;o<t.length;o++){i["option"+(o+1)]!=t[o]&&(a=!1)}return 1==a?void(e=i):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var i=this.variants[e];if(t==i.id)return i}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function i(t,e){return void 0===t?e:t}function a(t,e,a,o){if(e=i(e,2),a=i(a,","),o=i(o,"."),isNaN(t)||null==t)return 0;var n=(t=(t/100).toFixed(e)).split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",n=/\{\{\s*(\w+)\s*\}\}/,s=e||this.money_format;switch(s.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_apostrophe_separator":o=a(t,2);break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",")}return s.replace(n,o)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0};if(!this.selectVariantFromDropdown(t)){var e=this;setTimeout(function(){e.selectVariantFromParams(t)||e.fireOnChangeForFirstDropdown.call(e,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){this.selectVariantFromParams(t)||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),i=e.parentNode;Shopify.each(this.buildSelectors(),function(t){i.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var i=e.value;return this.selectVariant(i,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var i=this.product.getVariantById(t);if(null==i)return!1;for(var a=0;a<this.selectors.length;a++){var o=this.selectors[a].element,n=i[o.getAttribute("data-option")];null!=n&&this.optionExistInSelect(o,n)&&(o.value=n)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var i=0;i<t.options.length;i++)if(t.options[i].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var i=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){i.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var i=this.selectorDivClass,a=this.product.optionNames();return Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",i),a.length>1){var o=document.createElement("label");o.htmlFor=t.element.id,o.innerHTML=t.name,e.appendChild(o)}return e.appendChild(t.element),e})},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var i=this.selectors[e].element.value;t.push(i)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var i=this.selectedValues(),a=this.product.getVariant(i);a?(this.variantIdField.disabled=!1,this.variantIdField.value=a.id):this.variantIdField.disabled=!0,this.onVariantSelected(a,this,e),null!=this.historyState&&this.historyState.onVariantChange(a,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var i=e.optionNames||[],a=e.priceFieldExists||!0,o=e.delimiter||"/",n=this.createProductFromSelector(t,i,a,o);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,i,a){if(!Shopify.isDefined(i))i=!0;if(!Shopify.isDefined(a))a="/";var o=document.getElementById(t),n=o.childNodes,s=(o.parentNode,e.length),r=[];Shopify.each(n,function(t,o){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+a+"\\s*"));0==e.length&&(s=n.length-(i?1:0));var c=n.slice(0,s),l=i?n[s]:"",d=(t.getAttribute("value"),{available:!t.disabled,id:parseFloat(t.value),price:l,option1:c[0],option2:c[1],option3:c[2]});r.push(d)}});var c={variants:r};if(0==e.length){c.options=[];for(var l=0;s>l;l++)c.options[l]="option "+(l+1)}else c.options=e;return c},Shopify.SingleOptionSelector=function(t,e,i,a){this.multiSelector=t,this.values=a,this.index=e,this.name=i,this.element=document.createElement("select");for(var o=0;o<a.length;o++){var n=document.createElement("option");n.value=a[o],n.innerHTML=a[o],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(i,a){a=a||{},t.updateSelectors(e,a)},!0},Shopify.Image={preload:function(t,e){for(var i=0;i<t.length;i++){var a=t[i];this.loadImage(this.getSizedImageUrl(a,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,i){if(t&&e){var a=this.imageSize(e.src),o=this.getSizedImageUrl(t.src,a);i?i(o,t,e):e.src=o}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var i=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=i){var a=t.split(i[0]),o=i[0];return this.removeProtocol(a[0]+"_"+e+o)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,i){this.browserSupports()&&(!t||i.initialLoad||i.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState},$(document).on("shopify:block:select",function(t){var e=t.detail.blockId,i=$("#shopify-section-"+t.detail.sectionId);(i.hasClass("slideshow-section")||i.hasClass("testimonial-section"))&&sliderBlock.select(e,i),i.hasClass("recommended-products-section")&&$(".block__recommended_products").length&&productPage.init(),i.hasClass("page-details-section")&&$(".map-section").length&&mapFunction.init(),i.hasClass("cart-section")&&$(".block__featured_collection").length&&featuredCollectionSection.init(),i.hasClass("featured-products-section")&&(productPage.init(),productPage.initializeQuantityBox(),productPage.productSwatches(),Shopify.theme_settings.enable_shopify_review_comments&&$(".shopify-product-reviews-badge").length&&SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})),i.hasClass("product-template")&&Shopify.theme_settings.enable_shopify_review_comments&&$("#shopify-product-reviews").length>=1&&SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()}),utils.resizeActionButtons()}),$(document).on("shopify:block:deselect",function(t){var e=$("#shopify-section-"+t.detail.sectionId);(e.hasClass("slideshow-section")||e.hasClass("testimonial-section"))&&sliderBlock.deselect(e)}),$(document).on("shopify:section:reorder",function(t){utils.pageBannerCheck()}),$(document).on("shopify:section:load",function(t){var e=$("#shopify-section-"+t.detail.sectionId);utils.pageBannerCheck(),Shopify.theme_settings.newsletter_popup&&newsletter_popup.init(),e.hasClass("image-gallery-section")&&gallery.init(e),e.hasClass("social-feeds-section")&&$(".social-feeds-wrap").each(function(t,e){social.twitter();var i=$(this).find(".js-instafeed");instagram.loadContent({el:i,clientID:i.data("client-id"),limit:i.data("count"),column:i.data("column")})}),e.hasClass("faq-section")&&faqAccordion.init(),e.hasClass("cart-section")&&(cart.init(),$(".block__featured_collection").length&&featuredCollectionSection.init()),e.hasClass("featured-promotions-section")&&featuredPromotions.init(),e.hasClass("slideshow-section")&&slideshow.init(),Shopify.theme_settings.enable_autocomplete&&e.hasClass("search-section")&&searchAutocomplete.init(),e.hasClass("testimonial-section")&&testimonial.init(),e.hasClass("featured-products-section")&&(productPage.init(),productPage.initializeQuantityBox(),productPage.productSwatches(),Shopify.theme_settings.enable_shopify_review_comments&&$(".shopify-product-reviews-badge").length&&SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})),e.hasClass("map-section")&&mapFunction.init(),e.hasClass("featured-collection-section")&&featuredCollectionSection.init(),e.hasClass("video-section")&&videoSection.init(),e.hasClass("recently-viewed__section")&&recentlyViewed.init(),e.hasClass("product-template")&&(productPage.init(),productPage.productSwatches(),recentlyViewed.init(),Shopify.theme_settings.enable_shopify_review_comments&&($("#shopify-product-reviews").length||$(".shopify-product-reviews-badge").length)&&SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})),e.hasClass("recommended-products-section")&&productPage.init(),e.hasClass("article-template-section")&&-1!=window.location.pathname.indexOf("/comments")&&$("html,body").animate({scrollTop:$("#new-comment").offset().top-140},"slow"),e.hasClass("collection-template-section")&&(collectionSidebarFilter.init(),recentlyViewed.init()),e.hasClass("contact-section")&&mapFunction.init(),e.hasClass("search-template-section")&&(Shopify.theme_settings.enable_autocomplete&&searchAutocomplete.init(),collectionSidebarFilter.init()),e.hasClass("header-section")&&(header.init(),header.loadMegaMenu()),e.hasClass("mega-menu-section")&&header.loadMegaMenu(),e.hasClass("page-details-section")&&(featuredCollectionSection.init(),videoSection.init(),$(".block__image_gallery").length&&gallery.init(),recentlyViewed.init()),e.hasClass("product-details-section")&&(featuredCollectionSection.init(),videoSection.init(),mapFunction.init(),$(".block__image_gallery").length&&gallery.init(),recentlyViewed.init(),productPage.init())}),$(document).on("shopify:section:unload",function(t){var e=$(t.target),i=$("#shopify-section-"+t.detail.sectionId);i.hasClass("header-section")&&(header.unload(e),header.unloadMegaMenu()),i.hasClass("slideshow-section")&&slideshow.unload(e),i.hasClass("testimonial-section")&&testimonial.unload(e),i.hasClass("video-section")&&videoSection.unload(e),i.hasClass("search-section")&&searchAutocomplete.unload(e),i.hasClass("product-template")&&productPage.unload(e),i.hasClass("mega-menu-section")&&header.unloadMegaMenu(),i.hasClass("page-details-section")&&videoSection.unload(e),i.hasClass("product-details-section")&&videoSection.unload(e)}),$(document).on("shopify:section:select",function(t){var e=$("#shopify-section-"+t.detail.sectionId);if(e.hasClass("social-feeds-section")&&$(".social-feeds-wrap").each(function(t,e){social.twitter()}),e.hasClass("mega-menu-section")){var i=$(".header ."+t.detail.sectionId).data("dropdown");setTimeout(function(){$('a.mega-menu-parent[data-dropdown-rel="'+i+'"]').trigger("mouseenter"),$('a.mega-menu-parent[data-dropdown-rel="'+i+'"]').parents("header").addClass("editor-hover--true"),header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")},10)}e.hasClass("featured-collection-section")&&(featuredCollectionSection.unload(e),featuredCollectionSection.init()),utils.pageBannerCheck();var a=document.createEvent("UIEvents");a.initUIEvent("resize",!0,!1,window,0),window.dispatchEvent(a)}),$(document).on("shopify:section:deselect",function(t){if($("#shopify-section-"+t.detail.sectionId).hasClass("mega-menu-section")){var e=$(".header ."+t.detail.sectionId).data("dropdown");$('a.mega-menu-parent[data-dropdown-rel="'+e+'"]').trigger("mouseout"),$('a.mega-menu-parent[data-dropdown-rel="'+e+'"]').parents("header").removeClass("editor-hover--true")}});

function htmlEncode(t) {
    return t ? $("<div/>").text(t).html() : ""
}
function is_touch_device() {
    return "ontouchstart"in window || navigator.maxTouchPoints
}
$(function() {
    var oldFlickityCreate = window.Flickity.prototype._create, resizeTimeout;
    window.Flickity.prototype._create = function() {
        var t = this;
        return this.element.addEventListener && this.element.addEventListener("load", function() {
            t.onresize()
        }, !0),
        this._create = oldFlickityCreate,
        oldFlickityCreate.apply(this, arguments)
    }
    ,
    imageFunctions.flickityIosFix(),
    objectFitImages(),
    header.loadMegaMenu(),
    header.init(),
    Shopify.theme_settings.enable_autocomplete && searchAutocomplete.init(),
    utils.pageBannerCheck(),
    slideshow.init(),
    testimonial.init(),
    videoSection.init(),
    gallery.init(),
    featuredPromotions.init(),
    featuredCollectionSection.init(),
    collectionSidebarFilter.init(),
    cart.init(),
    mapFunction.init(),
    productPage.initializeQuantityBox(),
    productPage.init(),
    recentlyViewed.init(),
    window.addEventListener("resize", function(t) {
        resizeTimeout || (resizeTimeout = setTimeout(function() {
            resizeTimeout = null,
            $(window).width() <= 798 && (cart.init(),
            header.unload(),
            header.init())
        }, 66))
    }, !1),
    $.fancybox.defaults.animationEffect = "fade",
    $.fancybox.defaults.transitionEffect = "fade",
    $.fancybox.defaults.hash = !1,
    $.fancybox.defaults.infobar = !1,
    $.fancybox.defaults.toolbar = !1,
    $.fancybox.defaults.arrows = !1,
    $.fancybox.defaults.loop = !0,
    $.fancybox.defaults.smallBtn = !0,
    $.fancybox.defaults.live = !1,
    $.fancybox.defaults.zoom = !1,
    $.fancybox.defaults.mobile.preventCaptionOverlap = !1,
    $.fancybox.defaults.mobile.toolbar = !0,
    $.fancybox.defaults.mobile.buttons = ["close"],
    $.fancybox.defaults.mobile.clickSlide = "close",
    $.fancybox.defaults.mobile.clickContent = "zoom",
    $.fancybox.defaults.afterLoad = function(t, e) {
        "image" == t.current.type && e.$content.wrapInner("<div class='fancybox-image-wrap'></div>"),
        t.group.length > 1 && e.$content.find(".fancybox-image-wrap").append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' + svgArrowSizeLeft + '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' + svgArrowSizeRight + "</span></a>")
    }
    ,
    $('.lightbox[rel="gallery"]').fancybox(),
    $(".article_content iframe, .page iframe").wrap('<div class="lazyframe" data-ratio="16:9"></div>'),
    $(".shopify-policy__container").parent().prepend('<a name="pagecontent" id="pagecontent"></a>');
    var currentValue = $(".search_form input[name='q']").val();
    $(".search_form input[name='q']").length > 0 && $(".search_form input[name='q']").val(currentValue.replace("*", "")),
    $("#sort-by").val($("#sort-by").data("default-sort")),
    $("body").on("change", "#tag_filter, #sort-by", function() {
        quickFilter.init()
    }),
    $("body").on("change", "#blog_filter", function() {
        var t = $(this).val();
        window.location = t
    }),
    $("input, select, textarea").on("focus blur", function(t) {
        $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1,maximum-scale=" + ("blur" == t.type ? 10 : 1))
    }),
    $("body").on("change", "[data-option-filter] input", function() {
        quickFilter.init(),
        $("html, body").animate({
            scrollTop: $("#pagecontent").offset().top
        }, 500)
    }),
    $("body").on("click", "[data-reset-filters]", function() {
        collectionSidebarFilter.clearAllFilters()
    }),
    $("body").on("click", "[data-clear-filter]", function() {
        var t = $(this).parents(".filter-active-tag");
        collectionSidebarFilter.clearSelectedFilter(t)
    }),
    $("body").on("change", ".currencies", function(t) {
        $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
    }),
    $("body").on("change", ".js-quick-shop select", function(t) {
        var e = $('.js-quick-shop select[name="id"]').val();
        e && globalQuickShopProduct && quickShop.updateVariant(e)
    }),
    Shopify.theme_settings.quick_shop_enabled && quickShop.init();
    var touchStartPos = 0;
    if ($(document).bind("touchstart", function(t) {
        touchStartPos = $(window).scrollTop()
    }).bind("touchend", function(t) {
        var e = touchStartPos - $(window).scrollTop();
        (e > 20 || e < -20) && t.preventDefault
    }),
    $("body").on("click", ".sidebar .parent-link--false", function(t) {
        t.preventDefault(),
        $menu = $(this).parent("li"),
        $menu.find(".menu-toggle").toggleClass("active"),
        $menu.find("ul").slideToggle()
    }),
    Shopify.theme_settings.newsletter_popup && newsletter_popup.init(),
    -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"),
    $("body").on("mouseenter", ".icon-search", function() {
        $(".search-terms").focus()
    }),
    $("body").on("click", ".icon-search", function() {
        $("input.search-terms").focus()
    }),
    $("body").on("click", ".search-submit", function() {
        $(this).parent().submit()
    }),
    $(window).width() > 798 && ($(".animate_right").waypoint(function() {
        $(this.element).addClass("animated fadeInRight")
    }, {
        offset: "70%"
    }),
    $(".animate_left").waypoint(function() {
        $(this.element).addClass("animated fadeInLeft")
    }, {
        offset: "70%"
    }),
    $(".animate_up").waypoint(function() {
        $(this.element).addClass("animated fadeInUp")
    }, {
        offset: "70%"
    }),
    $(".animate_down").waypoint(function() {
        $(this.element).addClass("animated fadeInDown")
    }, {
        offset: "70%"
    })),
    $(".slider, .flexslider").find("li").unwrap(),
    $(".slider, .flexslider").flickity({
        pageDots: usePageDots,
        imagesLoaded: !0,
        arrowShape: arrowSize,
        lazyLoad: 2
    }),
    utils.createAccordion(".toggle-all--true", "h4.toggle", "ul.toggle_list"),
    utils.createAccordion(".footer_menu", "h6", "ul"),
    utils.createAccordion(".footer_content", "h6", "div.toggle_content"),
    utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"),
    utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"),
    utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"),
    utils.initializeTabs(),
    utils.resizeActionButtons(),
    faqAccordion.init(),
    $(window).on("resize", function() {
        utils.resizeActionButtons()
    }),
    $(window).width() <= 798 && utils.createAccordion(".toggle-all--false", "h4.toggle", "ul.toggle_list"),
    $("body").on("click", ".menu-toggle", function(t) {
        $(this).next("ul").slideToggle(),
        $(this).toggleClass("active"),
        $(this).attr("aria-expanded", "true" == $(this).attr("aria-expanded") ? "false" : "true")
    }),
    $(window).width() >= 959) {
        var modal_width = "870px";
        ($(window).width() >= 1200 || $("html").hasClass("ie")) && (modal_width = "1110px")
    }
    if (Shopify.theme_settings.collection_swatches && $(window).width() > 798 && ($("body").on("mouseenter", ".collection_swatches", function() {
        $(".swatch span", $(this)).each(function() {
            -1 == $(this).data("image").indexOf("no-image") && ($("<img/>")[0].src = $(this).data("image"))
        })
    }),
    $("body").on("mouseenter", ".swatch span", function() {
        -1 == $(this).data("image").indexOf("no-image") && ($(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("src", $(this).data("image")),
        $(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("srcset", $(this).data("image")))
    })),
    Shopify.theme_settings.display_tos_checkbox && $("body").on("click touchstart", ".cart_content .tos_label", function() {
        $(this).prev("input").prop("checked", !0)
    }),
    Shopify.theme_settings.display_tos_checkbox && Shopify.theme_settings.go_to_checkout ? $("body").on("click", ".tos_warning .action_button", function(t) {
        if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
            var e = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + "</p>";
            return 0 == $("p.warning").length && $(this).before(e),
            !1
        }
        Shopify.theme_settings.go_to_checkout ? $(this).submit() : (t.preventDefault(),
        document.location.href = "/cart")
    }) : Shopify.theme_settings.go_to_checkout || $("body").on("click", ".cart_content .action_button", function(t) {
        t.preventDefault(),
        document.location.href = "/cart"
    }),
    Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage(),
    $("[data-is-required]").length) {
        var $checkboxGroup = $(".contact-block--checkbox input");
        $checkboxGroup.prop("required", !0),
        $(".contact-block--checkbox [data-is-required] input").on("change", function() {
            $checkboxGroup.prop("required", !0),
            $checkboxGroup.is(":checked") && $checkboxGroup.prop("required", !1)
        })
    }
    var $contact_form = $(".newsletter .contact-form");
    function ajaxSubmitCart(t) {
        $cart = t,
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $cart.serialize(),
            success: function(t) {
                refreshCart(t)
            }
        })
    }
    function updateCartItemQuantity(t) {
        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: {
                quantity: t.quantity,
                line: t.lineID
            },
            success: function(e) {
                var i = e.items
                  , a = t.lineID - 1
                  , o = t.parentCartForm.find("[data-variant-id]").length
                  , n = t.parentCartForm.find('[data-variant-id="' + t.variantID + '"] input')
                  , s = 0
                  , r = 0
                  , c = void 0 !== e.items[a] ? e.items[a].quantity : 0;
                if (n.length > 1 ? ($.each(n, function(t, e) {
                    s += parseInt($(e).val())
                }),
                i.forEach(function(e) {
                    e.variant_id === t.variantID && (r += e.quantity)
                })) : (s = parseInt(n.val()),
                r = void 0 !== e.items[a] ? e.items[a].quantity : 0),
                s > 0 && s > r)
                    if (items_left_text = 1 == r ? Shopify.translation.one_item_left : Shopify.translation.items_left_text,
                    $(".warning--quantity").remove(),
                    o < i.length)
                        "cart-template" === t.parentCartForm.data("cart-form") ? t.parentCartForm.submit() : refreshCart(e);
                    else {
                        var l = '<p class="warning warning--quantity animated bounceIn">' + r + " " + items_left_text + "</p>";
                        t.parentCartForm.find("[data-line-id='" + t.lineID + "'] input").parent().after(l),
                        t.parentCartForm.find("[data-line-id='" + t.lineID + "'] input").val(c)
                    }
                else
                    "cart-template" === t.parentCartForm.data("cart-form") ? t.parentCartForm.submit() : refreshCart(e)
            }
        })
    }
    function refreshCartID() {
        for (var t = document.querySelectorAll(".cart__item"), e = 0; e < t.length; e++)
            for (var i = e + 1, a = t[e].querySelectorAll("[data-line-id]"), o = 0; o < a.length; o++)
                a[o].dataset.lineId = i
    }
    function refreshCart(t) {
        $(".cart_count").empty(),
        $cartBtn = $(".cart_count");
        var e = $cartBtn.text() || "0"
          , a = ""
          , o = ""
          , n = ""
          , s = ""
          , r = $("[data-cart-form]")
          , c = !1
          , l = 0
          , d = 0;
        if (r.data("total-discount", t.total_discount),
        $cartBtn.text(e.replace(/[0-9]+/, t.item_count)),
        0 == t.item_count)
            $(".js-empty-cart__message").removeClass("hidden"),
            r.addClass("hidden");
        else {
            $(".js-empty-cart__message").addClass("hidden"),
            r.removeClass("hidden");
            var p = 0
              , u = 0;

           var wcpcartdata = [];
            $.ajax({
                url: '/search?&view=wcp_cart',
                async: false,
                success: function (response) {
                    wcpcartdata = JSON.parse(response);
                }
            });

            t.total_price = wcpcartdata.wcp_cart_total;

            $.each(t.items, function(t, e) {
              
               $.each(wcpcartdata.items, function( index, wcp_val ) {   
                if(wcp_val.variant_id == e.variant_id){          
                    e.price = wcp_val.wcp_v_price;  
                    e.compare_at_price = wcp_val.wcp_v_compare_price;                 
                 return false;
                }
            }); 
              
                var o = e.discounts
                  , n = "";
                for (i = 0; i < o.length; i++) {
                    Shopify.formatMoney(o[i].amount, $("body").data("money-format"));
                    n = '<p class="notification-discount meta">' + o[i].title + "</p>"
                }
                var s = t + 1;
                if (a += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + s + '" data-variant-id="' + e.id + '"><a href="' + e.url + '">',
                e.image && (a += '<div class="cart_image"><img src="' + e.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") + '" alt="' + htmlEncode(e.title) + '" /></div></a>'),
                a += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + e.url + '">' + e.title + "</a></div>",
                e.properties && $.each(e.properties, function(t, e) {
                    e && (a += '<div class="line-item">' + t + ": " + e + " </div>")
                }),
                a += '<strong class="right price">',
                $.ajax({
                    dataType: "json",
                    async: !1,
                    cache: !1,
                    url: "/products/" + e.handle + ".js",
                    success: function(t) {
                        if (t.variants) {
                            var i = t.variants;
                            if (i.length > 1)
                                for (v = 0; v < i.length; v++)
                                    if (i[v].id == e.id)
                                        t = i[v]
                        }
                        t.compare_at_price ? t.compare_at_price > t.price && (c = !0,
                        l = t.compare_at_price,
                        d = t.price) : c = !1
                    }
                }),
                1 == c) {
                    var r = Shopify.formatMoney(d, $("body").data("money-format")) + ' </span><span class="money was_price">' + Shopify.formatMoney(l, $("body").data("money-format")) + "</span>";
                    a += '<span class="money sale">' + r + "</strong>",
                    u = (l - d) * e.quantity,
                    p = u + p
                } else if (e.price > e.final_price) {
                    r = Shopify.formatMoney(e.final_price, $("body").data("money-format")) + ' </span><span class="money was_price">' + Shopify.formatMoney(e.price, $("body").data("money-format")) + "</span>";
                    a += '<span class="money sale">' + r + "</strong>"
                } else {
                    r = Shopify.formatMoney(e.price, $("body").data("money-format"));
                    a += '<span class="money">' + r + "</span></strong>"
                }
                e.price > e.final_price && (a += n),
                a += '<div class="left product-quantity-box">',
                a += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>',
                a += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + e.id + '" value="' + e.quantity + '" data-cart-quantity-input="mini-cart" />',
                a += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>',
                a += "</div></div></div>",
                a += '<a href="/cart/change?line=' + s + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + s + '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>'
            });
            var h = t.cart_level_discount_applications;
            for (i = 0; i < h.length; i++) {
                var f = Shopify.formatMoney(h[i].total_allocated_amount, $("body").data("money-format"));
                o += '<span class="cart_discounts--title">' + h[i].title + "</span>",
                o += '<span class="cart_discounts--price">',
                o += '-<span class="money">' + f + "</span></span>"
            }
            n += '<span class="right"><span class="money">' + Shopify.formatMoney(t.total_price, $("body").data("money-format")) + "</span></span><span>" + Shopify.translation.cart_subtotal_text + "</span>",
            p += t.total_discount,
            s = Shopify.theme_settings.display_savings && p > 0 ? '<span class="right"><span class="money">' + Shopify.formatMoney(p, $("body").data("money-format")) + "</span></span><span>" + Shopify.translation.cart_savings_text + "</span>" : ""
        }
        $(".js-cart_items").html(a),
        $(".js-cart_discounts").html(o),
        $(".js-cart_subtotal").html(n),
        $(".js-cart_savings").html(s),
        Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
    }
    $contact_form.each(function() {
        var t = $(this);
        t.on("submit", function(e) {
            "true" !== $('input[name="challenge"]', t).val() && ($.ajax({
                type: t.attr("method"),
                url: t.attr("action"),
                data: t.serialize(),
                success: function(e) {
                    t.fadeOut("slow", function() {
                        t.prev(".message").html(Shopify.translation.newsletter_success_text)
                    })
                },
                error: function(e) {
                    $('input[name="challenge"]', t).val("true"),
                    t.submit()
                }
            }),
            e.preventDefault())
        })
    }),
    $(".maps").click(function() {
        $(".maps iframe").css("pointer-events", "auto")
    }),
    "load_more" == Shopify.theme_settings.pagination_type && enableLoadMoreProducts(),
    "infinite_scroll" == Shopify.theme_settings.pagination_type && enableInfiniteScroll(),
    "load_more" == Shopify.theme_settings.search_pagination_type && enableLoadMoreSearch(),
    "infinite_scroll" == Shopify.theme_settings.search_pagination_type && enableInfiniteSearchScroll(),
    $("body").on("change", "[data-cart-quantity-input]", function() {
        var t = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: $(this).val(),
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        $(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled"),
        updateCartItemQuantity(t)
    }),
    $("body").on("click", "[data-remove-item]", function(t) {
        t.preventDefault();
        var e = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: 0,
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        e.$element.addClass("animated fadeOutLeft"),
        updateCartItemQuantity(e),
        "cart-template" === e.parentCartForm.data("cart-form") && (e.$element.find("input").val("0"),
        e.parentCartForm.submit()),
        "mini-cart" === e.parentCartForm.data("cart-form") && e.$element.find("input").val("0")
    }),
    "ajax" == Shopify.theme_settings.cart_action && $(document).on("click", ".ajax-submit", function(e) {
        e.preventDefault();
        var $addToCartForm = $(this).closest("form")
          , $addToCartBtn = $addToCartForm.find(".add_to_cart");
        return $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $addToCartForm.serialize(),
            beforeSend: function() {
                $addToCartBtn.attr("disabled", "disabled").addClass("disabled"),
                $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
            },
            success: function(t) {
                $addToCartBtn.find(".checkmark").addClass("checkmark-active"),
                window.setTimeout(function() {
                    $addToCartBtn.removeAttr("disabled").removeClass("disabled"),
                    $addToCartBtn.find(".checkmark").removeClass("checkmark-active"),
                    $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                }, 1e3),
                $.ajax({
                    url: "/cart.js",
                    dataType: "json",
                    cache: !1,
                    success: function(t) {
                        setTimeout(function() {
                            (refreshCart(t),
                            $("body").hasClass("fancybox-active") && $.fancybox.close(),
                            $("#header").is(":visible") ? $("#header .cart_container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart_container").addClass("active_link") : $(".top_bar .cart_container").addClass("active_link"),
                            $(window).width() <= 798) && ($(this).parent().hasClass("active_link"),
                            $("body").addClass("blocked-scroll"));
                            $("body").hasClass("cart") && $addToCartForm.submit()
                        }, 500)
                    }
                })
            },
            error: function(XMLHttpRequest) {
                var response = eval("(" + XMLHttpRequest.responseText + ")");
                response = response.description,
                $(".warning").remove();
                var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                $addToCartForm.after(warning),
                $addToCartBtn.removeAttr("disabled").removeClass("disabled"),
                $addToCartBtn.find("span").text(Shopify.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn")
            }
        }),
        !1
    }),
    productPage.productSwatches()
}),
Shopify.updateOptionsInSelector = function(t, e) {
    switch (t) {
    case 0:
        var i = "root";
        $(e + " .single-option-selector:eq(0)");
        break;
    case 1:
        i = $(e + " .single-option-selector:eq(0)").val(),
        $(e + " .single-option-selector:eq(1)");
        break;
    case 2:
        i = $(e + " .single-option-selector:eq(0)").val();
        i += " / " + $(e + " .single-option-selector:eq(1)").val();
        $(e + " .single-option-selector:eq(2)")
    }
    var a = Shopify.optionsMap[i];
    $(e + ' .swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        -1 !== $.inArray($(this).attr("data-value"), a) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
    })
}
,
Shopify.linkOptionSelectors = function(t, e) {
    Shopify.optionsMap = {};
    for (var i = 0; i < t.variants.length; i++) {
        var a = t.variants[i];
        if (a.available) {
            if (Shopify.optionsMap.root = Shopify.optionsMap.root || [],
            Shopify.optionsMap.root.push(a.option1),
            Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root),
            t.options.length > 1) {
                var o = a.option1;
                Shopify.optionsMap[o] = Shopify.optionsMap[o] || [],
                Shopify.optionsMap[o].push(a.option2),
                Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
            }
            if (3 === t.options.length) {
                o = a.option1 + " / " + a.option2;
                Shopify.optionsMap[o] = Shopify.optionsMap[o] || [],
                Shopify.optionsMap[o].push(a.option3),
                Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
            }
        }
    }
    Shopify.updateOptionsInSelector(0, e),
    t.options.length > 1 && Shopify.updateOptionsInSelector(1, e),
    3 === t.options.length && Shopify.updateOptionsInSelector(2, e),
    $(e + " .single-option-selector:eq(0)").change(function() {
        return Shopify.updateOptionsInSelector(1, e),
        3 === t.options.length && Shopify.updateOptionsInSelector(2, e),
        !0
    }),
    $(e + " .single-option-selector:eq(1)").change(function() {
        return 3 === t.options.length && Shopify.updateOptionsInSelector(2, e),
        !0
    })
}
;
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
function floatToString(t, e) {
    var i = t.toFixed(e).toString();
    return i.match(/^\.\d+/) ? "0" + i : i
}
if (void 0 === Shopify)
    var Shopify = {};
Shopify.each = function(t, e) {
    for (var i = 0; i < t.length; i++)
        e(t[i], i)
}
,
Shopify.map = function(t, e) {
    for (var i = [], a = 0; a < t.length; a++)
        i.push(e(t[a], a));
    return i
}
,
Shopify.arrayIncludes = function(t, e) {
    for (var i = 0; i < t.length; i++)
        if (t[i] == e)
            return !0;
    return !1
}
,
Shopify.uniq = function(t) {
    for (var e = [], i = 0; i < t.length; i++)
        Shopify.arrayIncludes(e, t[i]) || e.push(t[i]);
    return e
}
,
Shopify.isDefined = function(t) {
    return void 0 !== t
}
,
Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}
,
Shopify.extend = function(t, e) {
    function i() {}
    i.prototype = e.prototype,
    t.prototype = new i,
    t.prototype.constructor = t,
    t.baseConstructor = e,
    t.superClass = e.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}
,
Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(t, e) {
    return (Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e) + Shopify.locationHash()
}
,
Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}
,
Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}
,
Shopify.Product.prototype.update = function(t) {
    for (property in t)
        this[property] = t[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var e = Shopify.map(this.variants, function(e) {
        var i = "option" + (t + 1);
        return null == e[i] ? null : e[i]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}
,
Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(i) {
        for (var a = !0, o = 0; o < t.length; o++) {
            i["option" + (o + 1)] != t[o] && (a = !1)
        }
        return 1 == a ? void (e = i) : void 0
    }),
    e)
}
,
Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var i = this.variants[e];
        if (t == i.id)
            return i
    }
    return null
}
,
Shopify.money_format = "$",
Shopify.formatMoney = function(t, e) {
    function i(t, e) {
        return void 0 === t ? e : t
    }
    function a(t, e, a, o) {
        if (e = i(e, 2),
        a = i(a, ","),
        o = i(o, "."),
        isNaN(t) || null == t)
            return 0;
        var n = (t = (t / 100).toFixed(e)).split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , s = e || this.money_format;
    switch (s.match(n)[1]) {
    case "amount":
        o = a(t, 2);
        break;
    case "amount_no_decimals":
        o = a(t, 0);
        break;
    case "amount_with_comma_separator":
        o = a(t, 2, ".", ",");
        break;
    case "amount_with_apostrophe_separator":
        o = a(t, 2);
        break;
    case "amount_no_decimals_with_comma_separator":
        o = a(t, 0, ".", ",")
    }
    return s.replace(n, o)
}
,
Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = t,
    this.product = new Shopify.Product(e.product),
    this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}
    ,
    this.replaceSelector(t),
    this.initDropdown(),
    e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    };
    if (!this.selectVariantFromDropdown(t)) {
        var e = this;
        setTimeout(function() {
            e.selectVariantFromParams(t) || e.fireOnChangeForFirstDropdown.call(e, t)
        })
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    this.selectVariantFromParams(t) || this.selectVariantFromDropdown(t)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t)
      , i = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        i.insertBefore(t, e)
    }),
    e.style.display = "none",
    this.variantIdField = e
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !e)
        return !1;
    var i = e.value;
    return this.selectVariant(i, t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var i = this.product.getVariantById(t);
    if (null == i)
        return !1;
    for (var a = 0; a < this.selectors.length; a++) {
        var o = this.selectors[a].element
          , n = i[o.getAttribute("data-option")];
        null != n && this.optionExistInSelect(o, n) && (o.value = n)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var i = 0; i < t.options.length; i++)
        if (t.options[i].value == e)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var i = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        i.appendChild(t)
    })
}
,
Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));
        e.element.disabled = !1,
        this.selectors.push(e)
    }
    var i = this.selectorDivClass
      , a = this.product.optionNames();
    return Shopify.map(this.selectors, function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", i),
        a.length > 1) {
            var o = document.createElement("label");
            o.htmlFor = t.element.id,
            o.innerHTML = t.name,
            e.appendChild(o)
        }
        return e.appendChild(t.element),
        e
    })
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var i = this.selectors[e].element.value;
        t.push(i)
    }
    return t
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var i = this.selectedValues()
      , a = this.product.getVariant(i);
    a ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = a.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(a, this, e),
    null != this.historyState && this.historyState.onVariantChange(a, this, e)
}
,
Shopify.OptionSelectorsFromDOM = function(t, e) {
    var i = e.optionNames || []
      , a = e.priceFieldExists || !0
      , o = e.delimiter || "/"
      , n = this.createProductFromSelector(t, i, a, o);
    e.product = n,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, i, a) {
    if (!Shopify.isDefined(i))
        i = !0;
    if (!Shopify.isDefined(a))
        a = "/";
    var o = document.getElementById(t)
      , n = o.childNodes
      , s = (o.parentNode,
    e.length)
      , r = [];
    Shopify.each(n, function(t, o) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + a + "\\s*"));
            0 == e.length && (s = n.length - (i ? 1 : 0));
            var c = n.slice(0, s)
              , l = i ? n[s] : ""
              , d = (t.getAttribute("value"),
            {
                available: !t.disabled,
                id: parseFloat(t.value),
                price: l,
                option1: c[0],
                option2: c[1],
                option3: c[2]
            });
            r.push(d)
        }
    });
    var c = {
        variants: r
    };
    if (0 == e.length) {
        c.options = [];
        for (var l = 0; s > l; l++)
            c.options[l] = "option " + (l + 1)
    } else
        c.options = e;
    return c
}
,
Shopify.SingleOptionSelector = function(t, e, i, a) {
    this.multiSelector = t,
    this.values = a,
    this.index = e,
    this.name = i,
    this.element = document.createElement("select");
    for (var o = 0; o < a.length; o++) {
        var n = document.createElement("option");
        n.value = a[o],
        n.innerHTML = a[o],
        this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (e + 1)),
    this.element.id = t.domIdPrefix + "-option-" + e,
    this.element.onchange = function(i, a) {
        a = a || {},
        t.updateSelectors(e, a)
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(t, e) {
        for (var i = 0; i < t.length; i++) {
            var a = t[i];
            this.loadImage(this.getSizedImageUrl(a, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, i) {
        if (t && e) {
            var a = this.imageSize(e.src)
              , o = this.getSizedImageUrl(t.src, a);
            i ? i(o, t, e) : e.src = o
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return this.removeProtocol(t);
        var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != i) {
            var a = t.split(i[0])
              , o = i[0];
            return this.removeProtocol(a[0] + "_" + e + o)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, i) {
    this.browserSupports() && (!t || i.initialLoad || i.popStateCall || Shopify.setParam("variant", t.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
,
$(document).on("shopify:block:select", function(t) {
    var e = t.detail.blockId
      , i = $("#shopify-section-" + t.detail.sectionId);
    (i.hasClass("slideshow-section") || i.hasClass("testimonial-section")) && sliderBlock.select(e, i),
    i.hasClass("recommended-products-section") && $(".block__recommended_products").length && productPage.init(),
    i.hasClass("page-details-section") && $(".map-section").length && mapFunction.init(),
    i.hasClass("cart-section") && $(".block__featured_collection").length && featuredCollectionSection.init(),
    i.hasClass("featured-products-section") && (productPage.init(),
    productPage.initializeQuantityBox(),
    productPage.productSwatches(),
    Shopify.theme_settings.enable_shopify_review_comments && $(".shopify-product-reviews-badge").length && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    })),
    i.hasClass("product-template") && Shopify.theme_settings.enable_shopify_review_comments && $("#shopify-product-reviews").length >= 1 && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    }),
    utils.resizeActionButtons()
}),
$(document).on("shopify:block:deselect", function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    (e.hasClass("slideshow-section") || e.hasClass("testimonial-section")) && sliderBlock.deselect(e)
}),
$(document).on("shopify:section:reorder", function(t) {
    utils.pageBannerCheck()
}),
$(document).on("shopify:section:load", function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    utils.pageBannerCheck(),
    Shopify.theme_settings.newsletter_popup && newsletter_popup.init(),
    e.hasClass("image-gallery-section") && gallery.init(e),
    e.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(t, e) {
        social.twitter();
        var i = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: i,
            clientID: i.data("client-id"),
            limit: i.data("count"),
            column: i.data("column")
        })
    }),
    e.hasClass("faq-section") && faqAccordion.init(),
    e.hasClass("cart-section") && (cart.init(),
    $(".block__featured_collection").length && featuredCollectionSection.init()),
    e.hasClass("featured-promotions-section") && featuredPromotions.init(),
    e.hasClass("slideshow-section") && slideshow.init(),
    Shopify.theme_settings.enable_autocomplete && e.hasClass("search-section") && searchAutocomplete.init(),
    e.hasClass("testimonial-section") && testimonial.init(),
    e.hasClass("featured-products-section") && (productPage.init(),
    productPage.initializeQuantityBox(),
    productPage.productSwatches(),
    Shopify.theme_settings.enable_shopify_review_comments && $(".shopify-product-reviews-badge").length && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    })),
    e.hasClass("map-section") && mapFunction.init(),
    e.hasClass("featured-collection-section") && featuredCollectionSection.init(),
    e.hasClass("video-section") && videoSection.init(),
    e.hasClass("recently-viewed__section") && recentlyViewed.init(),
    e.hasClass("product-template") && (productPage.init(),
    productPage.productSwatches(),
    recentlyViewed.init(),
    Shopify.theme_settings.enable_shopify_review_comments && ($("#shopify-product-reviews").length || $(".shopify-product-reviews-badge").length) && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    })),
    e.hasClass("recommended-products-section") && productPage.init(),
    e.hasClass("article-template-section") && -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"),
    e.hasClass("collection-template-section") && (collectionSidebarFilter.init(),
    recentlyViewed.init()),
    e.hasClass("contact-section") && mapFunction.init(),
    e.hasClass("search-template-section") && (Shopify.theme_settings.enable_autocomplete && searchAutocomplete.init(),
    collectionSidebarFilter.init()),
    e.hasClass("header-section") && (header.init(),
    header.loadMegaMenu()),
    e.hasClass("mega-menu-section") && header.loadMegaMenu(),
    e.hasClass("page-details-section") && (featuredCollectionSection.init(),
    videoSection.init(),
    $(".block__image_gallery").length && gallery.init(),
    recentlyViewed.init()),
    e.hasClass("product-details-section") && (featuredCollectionSection.init(),
    videoSection.init(),
    mapFunction.init(),
    $(".block__image_gallery").length && gallery.init(),
    recentlyViewed.init(),
    productPage.init())
}),
$(document).on("shopify:section:unload", function(t) {
    var e = $(t.target)
      , i = $("#shopify-section-" + t.detail.sectionId);
    i.hasClass("header-section") && (header.unload(e),
    header.unloadMegaMenu()),
    i.hasClass("slideshow-section") && slideshow.unload(e),
    i.hasClass("testimonial-section") && testimonial.unload(e),
    i.hasClass("video-section") && videoSection.unload(e),
    i.hasClass("search-section") && searchAutocomplete.unload(e),
    i.hasClass("product-template") && productPage.unload(e),
    i.hasClass("mega-menu-section") && header.unloadMegaMenu(),
    i.hasClass("page-details-section") && videoSection.unload(e),
    i.hasClass("product-details-section") && videoSection.unload(e)
}),
$(document).on("shopify:section:select", function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    if (e.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(t, e) {
        social.twitter()
    }),
    e.hasClass("mega-menu-section")) {
        var i = $(".header ." + t.detail.sectionId).data("dropdown");
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').trigger("mouseenter"),
            $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').parents("header").addClass("editor-hover--true"),
            header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")
        }, 10)
    }
    e.hasClass("featured-collection-section") && (featuredCollectionSection.unload(e),
    featuredCollectionSection.init()),
    utils.pageBannerCheck();
    var a = document.createEvent("UIEvents");
    a.initUIEvent("resize", !0, !1, window, 0),
    window.dispatchEvent(a)
}),
$(document).on("shopify:section:deselect", function(t) {
    if ($("#shopify-section-" + t.detail.sectionId).hasClass("mega-menu-section")) {
        var e = $(".header ." + t.detail.sectionId).data("dropdown");
        $('a.mega-menu-parent[data-dropdown-rel="' + e + '"]').trigger("mouseout"),
        $('a.mega-menu-parent[data-dropdown-rel="' + e + '"]').parents("header").removeClass("editor-hover--true")
    }
});
